var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative",staticStyle:{"top":"-10px"}},[_c('div',{staticClass:"sticky-tabs"},[_c('b-tabs',{attrs:{"content-class":"mt-3"}},[_c('b-tab',{attrs:{"title":"New Board","active":""}},[_c('NewBoardTab')],1),_c('b-tab',{attrs:{"title":"Existing Board"}},[_c('ExistingBoardTab')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }